export default ({React,connect,CollapsePanel,Icon,DataGrid,slate,Modal,FormGroup,ToasterActions,Confirm})->

  { Block, Text } = slate

  class QuizToolbar extends React.Component

    constructor:(props)->
      super(props)
      @state = {
        id:null
        quizzes:[]
        selected:[]
        loading:false
        editing:false
        quiz:{questions:[]}
        saving:false
        questionsSelected:[]
      }

    componentDidMount:->
      @loadQuizzes()

    loadQuizzes:->
      @stateFromTag()
      @setState({loading:true})
      fetch("/duocms/api/quizzes")
      .then (res)=> res.json() 
      .then (res)=>
        selected = res.data.filter (q)=> +q.id == +@state.id 
        questionsSelected = @state.quiz.questions.filter (q)=> +q.id == +@state.questionsSelected[0].id 
        @setState({quizzes:res.data,loading:false,selected,questionsSelected})
        
    componentDidUpdate:(prev_props,prev_state)->
      @stateFromTag() if prev_props.value.change().value.startBlock != @props.value.change().value.startBlock 

    stateFromTag:->
      tag = @getTag()
      return if !tag
      attrs = tag.data.toObject()
      @setState({id:attrs.id}) if attrs.id 
     
    getTag:->
      change = @props.value.change()
      tags = change.value.blocks.filter (node)-> node.type == "duoquiz"
      return tags.get(0) if tags.size > 0

    updateEditor:()->
      tag = @getTag()
      return if !tag
      change = @props.value.change()
      attrs = {}
      attrs.id = if @state.id then @state.id else null
      change.setNodeByKey(tag.key, {data: {...tag.data.toObject(),...attrs}}) 
      @props.setValue(change.value)

    selectQuiz:(quiz)->
      @setState({selected:[quiz],id:quiz.id},=>  @updateEditor())

    addQuiz:()->
      @setState({quiz:{questions:[]},editing:true})
    
    deleteQuiz:()->
      id = @state.selected[0].id
      @setState({loading:true,selected:[]})
      fetch("/duocms/api/quizzes/#{id}",{
        headers: new Headers({'content-type': 'application/json','X-CSRF-Token':window._csrf})
        credentials: 'same-origin'
        method: "DELETE"
      }).then (res)=>  
        @loadQuizzes()

    editQuiz:(quiz)->
      fetch("/duocms/api/quizzes/"+@state.selected[0].id)
      .then (res)=> res.json()
      .then (res)=>
        @setState({quiz:res.data,editing:true})

    saveQuiz:->
      @setState({saving:true})
      if @state.quiz.id
        url = "/duocms/api/quizzes/"+@state.quiz.id
        method = "PUT"
      else
        url = "/duocms/api/quizzes"
        method = "POST"
      status = null
      fetch(url,{
        headers: new Headers({'content-type': 'application/json','X-CSRF-Token':window._csrf})
        credentials: 'same-origin'
        method: method
        body:JSON.stringify(@state.quiz)
      }).then (res)=>  
        status = res.status
        res.json()
      .then (res)=>
        if status == 200
          @props.dispatch(ToasterActions.toastAdd({title:"Success",message:"Quiz Saved Successfully",type:"success"}))
          @setState({saving:false,quiz:res.data})
          @loadQuizzes()
        else
          @props.dispatch(ToasterActions.toastAdd({title:"Error",message:res.message,type:"error"}))
          @setState({saving:false})
       

    onUpdate:(field,value)->
      quiz = @state.quiz 
      quiz[field] = value 
      @setState({quiz})

    updateQuestion:(field,value)->
      quiz = @state.quiz 
      idx = quiz.questions.findIndex (q)=> @state.questionsSelected[0].id == q.id
      quiz.questions[idx][field] = value 
      @setState({quiz,questionsSelected:[quiz.questions[idx]]})

    updateOption:(idx,value)->
      options = @state.questionsSelected[0].options
      options[idx] = value 
      @updateQuestion("options",options)

    addOption:->
      options = @state.questionsSelected[0].options
      options = options.concat("") 
      @updateQuestion("options",options)

    removeOption:(idx)->
      options = @state.questionsSelected[0].options
      options = options.filter (_,x)=> x!=idx
      @updateQuestion("options",options)

    addQuestion:->
      quiz = @state.quiz 
      quiz.questions.push({
        id:crypto.randomUUID()
        question:"New Questions"
        marks:1,
        options:["True","False"]
      })
      @setState({quiz})

    deleteQuestion:->
      quiz = @state.quiz 
      quiz.questions =  quiz.questions.filter (q)=> q.id != @state.questionsSelected[0].id
      @setState({quiz,questionsSelected:[]})

    title:->
      <div class="title">
        <FormGroup label="Quiz Title" key="name">
          <input type="text" className="form-control" id="name" placeholder="eg My First Quiz" value={@state.quiz.name} onChange={(e)=> @onUpdate("name",e.target.value)} />
        </FormGroup>
      </div>

    render:->
      columns = [
        {label:"Title",field:"name",width:550},
        {label:"Questions",field:"questions",width:90},
      ]
      <CollapsePanel title="Quiz Tools">
        <div className="btn-toolbar" style={{maxWidth:180,paddingBottom:0}}>
          <button title="Add Quiz" data-balloon="Add Quiz" data-balloon-pos="up" className="btn" onClick={()=> @addQuiz() } ><Icon icon="plus" /></button>
          <button title="Edit Quiz" disabled={!@state.selected?.length} data-balloon="Edit Quiz" data-balloon-pos="up" className="btn" onClick={()=> @editQuiz() } ><Icon icon="edit" /></button>
          <Confirm title="Delete Quiz" disabled={!@state.selected?.length} data-balloon="Delete Quiz" data-balloon-pos="up" className="btn" onClick={()=> @deleteQuiz() } ><Icon icon="trash" /></Confirm>
          <Icon icon="add" size="lg" />
        </div>
        <div className="pagelist">
          <DataGrid
            style={{height:"calc(100% - 25px)"}}
            rows={@state.quizzes}
            selected={@state.selected}
            multiselect={true}
            columns={columns}
            onRowClick={(selectedRows)=> @selectQuiz(selectedRows[0]) }
            onRowDoubleClick={(selectedRows)=> @editQuiz(selectedRows[0]) }
          />
          {if @state.loading
            <div className="react-grid-FooterRow"><span className="fa fa-refresh fa-spin" /> Loading Quizzes</div>
          else
            <div className="react-grid-FooterRow">{@state.quizzes.length} Quizzes</div>
          }
        </div>
        {if @state.editing
          <Modal>
            <div className="modal-backdrop" />
            <div className="modal quizmodal">
              <div className="title">Quiz</div>
              {if @state.quiz?.id
                <div className="body">
                  {@title()}
                  <div class="tools">
                    <button title="Add Question" data-balloon="Add Question" data-balloon-pos="up" className="btn" onClick={()=> @addQuestion() } ><Icon icon="plus" /></button>
                    <button title="Delete Question" data-balloon="Delete Question" data-balloon-pos="up" disabled={!@state.questionsSelected?.length} className="btn" onClick={()=> @deleteQuestion() } ><Icon icon="trash" /></button>
                  </div>

                  <div className="questionlist">
                    <DataGrid
                      style={{height:"calc(100% - 25px)"}}
                      rows={@state.quiz.questions}
                      selected={@state.questionsSelected}
                      multiselect={false}
                      columns={[
                        {label:"Question",field:"question",width:550},
                        {label:"options",field:"options",width:90,component:(props)=> props.rowData?.options?.length },
                      ]}
                      onRowClick={(selectedRows)=> @setState({questionsSelected:selectedRows})}
                      onRowDoubleClick={(selectedRows)=> @setState({questionsSelected:selectedRows})}
                    />
                    <div className="react-grid-FooterRow">{@state.quiz.questions.length} Questions</div>
                  </div>
                  <div class="question">
                    {if !@state.questionsSelected.length
                      <div className="alert alert-info">
                        <p>Please selected a question opposite.</p>
                      </div>
                    else  
                      <React.Fragment>
                        <FormGroup label="Question" key="question">
                          <textarea className="form-control" id="question" rows="3" value={@state.questionsSelected?[0]?.question} placeholder="eg Pick the correct thing?" disabled={!@state.questionsSelected.length} onChange={(e)=> @updateQuestion("question",e.target.value)} />
                        </FormGroup>
                        <FormGroup label="Marks" key="marks">
                          <input type="number" className="form-control" id="marks" value={@state.questionsSelected?[0]?.marks} placehodler="1" disabled={!@state.questionsSelected.length} onChange={(e)=> @updateQuestion("marks",e.target.value)}   />
                        </FormGroup>
                        <FormGroup label="Options" key="options">
                          {@state.questionsSelected?[0]?.options?.map (op,idx)=>
                            <div className="optionrow">
                              <button className="btn btn-default" onClick={()=> @removeOption(idx)} >&times;</button>
                              <input type="text" className="form-control" key={"op"+idx} value={op} onChange={(e)=> @updateOption(idx,e.target.value)} />
                              <input type="radio" name="correct" checked={@state.questionsSelected?[0]?.answer? && idx == +@state.questionsSelected?[0]?.answer}  onClick={(e)=> @updateQuestion("answer",idx)} />
                            </div>
                          }
                          {if @state.questionsSelected.length
                            <button className="btn btn-default btn-add" onClick={()=> @addOption()}>Add Option</button>
                          }
                        </FormGroup>
                      </React.Fragment>
                    }
                  </div>
                  
                </div>
              else
                <div className="body">
                  {@title()}
                </div>
              }
              <div className="btn-toolbar pull-right">
                <button className="btn btn-primary btn-lg" onClick={=> @saveQuiz() }>Save</button>
                <button className="btn btn-default btn-lg" onClick={=> @setState({editing:false,questionsSelected:[]})}>Close</button>
              </div>
            </div>
          </Modal>
        }
      </CollapsePanel>

  connect(
    (state)->
      settings:state.settings
      toolbar_width:state.toolbar_width
      toolbars_active:state.toolbars_active
  )(QuizToolbar)